import { Grid } from "antd";
import { useForm } from "antd/es/form/Form";
import { FC, useEffect } from "react";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { useJourneyListingContext } from "../../context/JourneyListingContext";
import { useDebounceFn } from "src/hooks/useDebounce";
import { generateInitialFilterValues, generateNoneFilterValues } from "../../utils";
import { CheckboxGroup, Range } from "src/components/Filters";
import { track } from "@amplitude/analytics-browser";
import FiltersBarWeb from "./layouts/FiltersBar.web";
import FiltersBarMob from "./layouts/FiltersBar.mob";

const FiltersBarComponent = withConditionalComponent(FiltersBarWeb, FiltersBarMob);

const FiltersBar: FC<{ dataGroups: any }> = ({ dataGroups }) => {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const [form] = useForm();
  const { filtersState, searchObject, isFetching, dataCount } = useJourneyListingContext();
  const [filters, setFilters] = filtersState;
  const hasReturnFilters = searchObject.journeyType === 2;

  const debouncedUpdateFilters = useDebounceFn(setFilters, 200);

  const initialValues = generateInitialFilterValues(dataGroups);

  const noneValues = generateNoneFilterValues(dataGroups);

  const handleChange = (changedValues: any, allValues: Record<string, any>) => {
    debouncedUpdateFilters(allValues);
    track("Filters Updated", {
      ...changedValues,
    });
  };

  const handleReset = () => {
    debouncedUpdateFilters(initialValues);
    track("Filters Reset");
  };

  useEffect(() => {
    if (dataGroups) {
      form.setFieldsValue(initialValues);
      debouncedUpdateFilters(initialValues);
    }
  }, [dataGroups]);

  useEffect(() => {
    form.setFieldsValue(filters);
  }, [filters]);

  const handleClearGroup = (key: string) => {
    const newFilters = {
      ...filters,
      [key]: noneValues[key],
    };
    debouncedUpdateFilters(newFilters);
  };
  const handleResetGroup = (key: string) => {
    const newFilters = {
      ...filters,
      [key]: initialValues[key],
    };
    debouncedUpdateFilters(newFilters);
  };
  const filterComponents = {
    checkbox: {
      Component: CheckboxGroup,
      onClear: handleClearGroup,
      onReset: handleResetGroup,
    },
    range: {
      Component: Range,
    },
  };

  return (
    <FiltersBarComponent
      trigger={isLargeScreen}
      props={{
        form,
        initialValues,
        handleChange,
        handleReset,
        dataCount,
        isFetching,
        dataGroups,
        hasReturnFilters,
        filterComponents,
      }}
    />
  );
};

export default FiltersBar;
